<div class="card">
    <form class="g-3" name="EmployeeForm" (ngSubmit)="Validate(EmployeeForm)" #EmployeeForm="ngForm" novalidate>
        <div class="card-header">
            {{common.ToLowerCase(EmployeeDetail.RegistrationType) ==
            'manual'?'Employee':common.ToLowerCase(EmployeeDetail.RegistrationType) == 'preonboarding'?'Candidate':''}}
            Registration
        </div>
        <div class="card-body">
            <div class="row pb-3">
                <div class="col-md-6">
                    <label for="FirstName" class="form-font-label">Full Name<span
                            class="mandatory-field">*</span></label>
                    <input type="text" class="form-control" placeholder="Ex. John Alexander" id="FirstName"
                        name="FirstName" [(ngModel)]="EmployeeDetail.FirstName" #FirstName="ngModel" maxlength="100"
                        pattern="[a-zA-Z ]*" (keypress)="common.AlphabetOnly($event,true)"
                        (input)="common.ToUpperCaseE($event)" required>
                    <div class="invalid-feedback">
                        Please enter full name!
                    </div>
                </div>
                <div class="col-md-3">
                    <label for="EmailId" class="form-font-label">Email ID<span class="mandatory-field" *ngIf="this.common.ToLowerCase(this.EmployeeDetail.RegistrationType) == 'preonboarding'">*</span></label>
                    <input type="email" class="form-control" placeholder="Ex. xyz@domain.com" id="EmailId"
                        name="EmailId" [(ngModel)]="EmployeeDetail.EmailId" #EmailId="ngModel"
                        pattern="[A-Za-z0-9._+\-']+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}$" maxlength="50"
                        (input)="common.ToUpperCaseE($event)" [required]="this.common.ToLowerCase(this.EmployeeDetail.RegistrationType) == 'preonboarding'">
                    <div class="invalid-feedback">
                        Please enter email Id! eg. 'example&#64;abc.com'
                    </div>
                </div>
                <div class="col-md-3">
                    <label for="MobileNo" class="form-font-label">Phone No<span class="mandatory-field">*</span></label>
                    <input type="text" minlength="10" maxlength="10" pattern="^(?:[1-9]\d*|0)$" class="form-control"
                        (keypress)="common.NumberOnly($event)" placeholder="Ex. 9876543210" id="MobileNo"
                        name="MobileNo" [(ngModel)]="EmployeeDetail.MobileNo" #MobileNo="ngModel" required>
                    <div class="invalid-feedback">
                        Please enter mobile no!
                    </div>
                </div>
            </div>
            <div class="row pb-3">
                <div class="col-md-6">
                    <label for="RegistrationType" class="form-font-label">Registration Type<span
                            class="mandatory-field">*</span> : </label>
                    <div class="btn-group btn-group-toggle">
                        @for (RegistrationType of RegistrationTypesFilter; track RegistrationType.RegistrationType; let
                        i =
                        $index) {
                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                            <input class="form-check-input" type="radio" [value]=RegistrationType.Value
                                name='RegistrationType' [(ngModel)]="EmployeeDetail.RegistrationType"
                                [ngModelOptions]="{standalone: true}">
                            {{RegistrationType.RegistrationType}}
                        </label>
                        }
                    </div>
                </div>
                <div class="col-md-6">
                    <label for="EmployeeCategory" class="form-font-label">Employee Type<span
                            class="mandatory-field">*</span> : </label>
                    <div class="btn-group btn-group-toggle">
                        @for (EmployeeCategory of common.EmployeeCategorys; track EmployeeCategory.EmployeeCategory; let
                        i =
                        $index) {
                        <label class="form-check-label link-dark px-1" ngbButtonLabel *ngIf="this.common.ToLowerCase(EmployeeCategory.EmployeeCategory) == this.common.ToLowerCase(this.EmployeeDetail.EmployeeCategory)">
                            <input class="form-check-input" type="radio" [value]=EmployeeCategory.Value
                                name='EmployeeCategory' [(ngModel)]="EmployeeDetail.EmployeeCategory"
                                [ngModelOptions]="{standalone: true}">
                            {{EmployeeCategory.EmployeeCategory}}
                        </label>
                        }
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>
                <button *ngIf="this.common.PageRight.IsAdd" type="submit" class="btn btn-primary"
                    [disabled]="isDisabled"><i class="bi bi-chevron-right" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Next':'Loading...'}}</button>
            </div>
        </div>
    </form>
</div>